export enum ModuleItems {
    None = 0,
    Activities_VirtualClass = 1,
    Activities_Survey = 2,
    Activities_Forum = 3,
    Calendar_ExternalUrl = 4,
    Activities_Wall = 5,
    Activities_Assignment = 6,
    Activities_Elesson = 7,
    Activities_Exam = 8,
    Activities_Video = 9,
    Activities_Document = 10,
    Activities_Telegram = 11,
    Survey = 100,
    Forum = 110,
    Messaging = 120,
    Class_TeacherSelfEnrollment = 130,
    Help = 140,
    Announcement = 150,
    ShowStartUp_Announcement = 151,
    Feed = 180,
    Feed_Dashboard = 181,
    Feed_Course = 182,
    Feed_Profile = 183,

    Morpa = 9001,
    Dersdeo = 9002,

    Certificate = 200,
    Activities_Dictionary = 170,
    Activities_Link = 171,
    Activities_GenericLink = 172,
    Activities_LTI = 173
}